module.exports = __webpack_public_path__ + "static/media/Opportunity_Dashboard.7a409709.png";